import React, { useEffect } from 'react';
import gsap from 'gsap';

interface FloatingShapesProps {
    variant?: 'default' | 'minimal' | 'dense';
}

export const FloatingShapes: React.FC<FloatingShapesProps> = ({ variant = 'default' }) => {
    useEffect(() => {


        const shapes = document.querySelectorAll('.geo-shape');
        shapes.forEach((elem: any, i: number) => {
            gsap.to(elem, {
                y: -30,
                rotation: 15,
                repeat: -1,
                yoyo: true,
                duration: 3 + i * 0.5,
                ease: 'sine.inOut'
            });
        });
    }, []);

    const defaultShapes = (
        <>
            {/* Square - top left */}
            <div className="geo-shape absolute top-10 left-10 w-12 h-12 sm:w-16 sm:h-16 lg:w-20 lg:h-20 bg-[var(--primary-blue)] opacity-20"></div>

            {/* Striped pattern - top right */}
            <div className="geo-shape absolute top-40 right-20 w-20 h-20 sm:w-24 sm:h-24 lg:w-32 lg:h-32 opacity-30" style={{
                background: 'repeating-linear-gradient(45deg, transparent, transparent 10px, var(--primary-blue) 10px, var(--primary-blue) 20px)'
            }}></div>

            {/* Circle - bottom left */}
            <div className="geo-shape absolute bottom-20 left-1/3 w-16 h-16 sm:w-20 sm:h-20 lg:w-24 lg:h-24 bg-gold opacity-20 rounded-full"></div>
        </>
    );

    const minimalShapes = (
        <>
            {/* Small square */}
            <div className="geo-shape absolute top-20 right-10 w-12 h-12 sm:w-14 sm:h-14 lg:w-16 lg:h-16 bg-[var(--primary-blue)] opacity-15"></div>

            {/* Circle */}
            <div className="geo-shape absolute bottom-32 left-20 w-14 h-14 sm:w-16 sm:h-16 lg:w-20 lg:h-20 bg-gold opacity-15 rounded-full"></div>
        </>
    );

    const denseShapes = (
        <>
            {/* Multiple squares and circles */}
            <div className="geo-shape absolute top-10 left-10 w-12 h-12 sm:w-16 sm:h-16 lg:w-20 lg:h-20 bg-[var(--primary-blue)] opacity-20"></div>
            <div className="geo-shape absolute top-40 right-20 w-20 h-20 sm:w-24 sm:h-24 lg:w-32 lg:h-32 opacity-30" style={{
                background: 'repeating-linear-gradient(45deg, transparent, transparent 10px, var(--primary-blue) 10px, var(--primary-blue) 20px)'
            }}></div>
            <div className="geo-shape absolute bottom-20 left-1/3 w-16 h-16 sm:w-20 sm:h-20 lg:w-24 lg:h-24 bg-gold opacity-20 rounded-full"></div>
            <div className="geo-shape absolute top-1/2 right-10 w-12 h-12 sm:w-14 sm:h-14 lg:w-16 lg:h-16 bg-[var(--primary-blue)] opacity-15"></div>
            <div className="geo-shape absolute bottom-40 right-1/4 w-20 h-20 sm:w-24 sm:h-24 lg:w-28 lg:h-28 opacity-25" style={{
                background: 'repeating-linear-gradient(0deg, transparent, transparent 8px, var(--gold) 8px, var(--gold) 16px)'
            }}></div>
        </>
    );

    return (
        <>
            {variant === 'default' && defaultShapes}
            {variant === 'minimal' && minimalShapes}
            {variant === 'dense' && denseShapes}
        </>
    );
};
